import Alert from '@storeblocks/alert';
import { InsuranceDetails } from 'Api/insurance';
import { WrapMdMarginBottom } from 'App/global-style';
import React, { ReactElement } from 'react';
import { getCancellationAlertTexts } from './underCancellationAlert.helpers';

interface UnderCancellationAlertProps {
  insurance: InsuranceDetails;
  cwpDetailToggle: boolean;
}

export const UnderCancellationAlert = ({
  insurance,
  cwpDetailToggle,
}: UnderCancellationAlertProps): ReactElement => {
  const { alertTitle, alertDescription } = getCancellationAlertTexts(
    insurance,
    cwpDetailToggle,
  );

  return (
    <WrapMdMarginBottom>
      <Alert title={alertTitle} description={alertDescription} />
    </WrapMdMarginBottom>
  );
};
